module.exports = __webpack_public_path__ + "img/lg_ring_g_i_null_0.6b1f7edf.png";